export default function Pagination({ page, pageSize, total, onChange }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-between mt-4 text-sm" data-testid="pagination">
      <span className="text-muted-foreground">
        {total === 0 ? 0 : (page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} z {total}
      </span>
      <div className="flex items-center gap-2">
        <button
          data-testid="page-prev"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
          className="px-3 h-8 rounded-md border border-border disabled:opacity-40 hover:bg-secondary transition-colors"
        >
          Předchozí
        </button>
        <span className="text-muted-foreground">
          {page} / {pages}
        </span>
        <button
          data-testid="page-next"
          disabled={page >= pages}
          onClick={() => onChange(page + 1)}
          className="px-3 h-8 rounded-md border border-border disabled:opacity-40 hover:bg-secondary transition-colors"
        >
          Další
        </button>
      </div>
    </div>
  );
}
